import React from 'react'
import style from './startsoon.module.css'

function Mathbyanuj() {
  return (
    <div  className = {style.start_soon}>
      <img src='https://edge.uacdn.net/static/thumbnail/course/fde8dcecd7c4457cb4d77da79d277f43.png?q=100&w=512' alt='_Sumit_img' />
      <div>
        <p>HINDI   MATHEMATICS</p>
        <h4>Commando 2.0: Course on Mathematics</h4> 
        <p>Starts on Mar 7, 2022 • 24 lessons</p> 
        <p>Anuj Seth</p>
      </div>
    </div>        
  )
}
export default Mathbyanuj;